import React from "react";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBadgeImages,
  selectProgressPercentageForSection,
} from "../../store/selectors";
import ModuleHeader from "../modules/ModuleHeader";
import BadgeInactiveButtons from "../badge/BadgeInactiveButtons";
import BadgeActiveButtons from "../badge/BadgeActiveButtons";
import { toggleShareBadgeModal } from "../../store/actions";
import { userSetsSectionThunk } from "../../store/thunks";
import { trackAdobeAppClick, trackAdobeClick } from "../../utils/adobeLogging";

const BadgesPage = () => {
  useClearCurrentTopic();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const badges = useSelector(selectBadgeImages);
  const agileProgress = useSelector((state) =>
    selectProgressPercentageForSection(state, "PMAgile")
  );
  const waterfallProgress = useSelector((state) =>
    selectProgressPercentageForSection(state, "PMWaterfall")
  );

  const language = useSelector((state) => state.ui.lang);
  const section = useSelector((state) => state.progress.section);
  const waterfallBadge = `/images/badges/kickoff-badge-wf${language}.png`;
  const agileBadge = `/images/badges/kickoff-badge-ag${language}.png`;

  const switchSection = (e, section, title) => {
    e.preventDefault();
    trackAdobeClick(null, {
      linkTitle: title,
      linkModule: `${section}-earn-badges`,
      targetURL: "/app/earn-badges",
    });
    dispatch(userSetsSectionThunk(section));
  };

  const trackDownload = (badgeFileName, badgePath) => {
    trackAdobeAppClick({ action: "download-badge", language:language });
    trackAdobeClick(
      { fileName: badgeFileName, fileLanguage: language },
      {
        linkTitle: t("download"),
        linkModule: `${section}-earn-badges`,
        targetURL: badgePath,
      }
    );
  };
  const trackShare = (badgePath) => {
    trackAdobeAppClick({action: "share", language: language})
    trackAdobeClick(
      null,
      {
        linkTitle: t("share"),
        linkModule: `${section}-earn-badges`,
        targetURL: badgePath,
      }
    );
    dispatch(toggleShareBadgeModal());
  } 
  return (
    <div>
      <ModuleHeader title={t("earnBadgesHeader")} />

      <div className="lg:px-0 px-3" adoberegion={`${section}-earn-badges`}>
        <div className="bg-white shadow rounded py-10 px-10 min-h-screen">
          <div className="flex">
            <div className="w-1/3">
              <img
                style={{ opacity: waterfallProgress === 100 ? 1 : 0.4 }}
                src={waterfallBadge}
                alt=""
              />
            </div>
            <div className="ml-8 w-2/3">
              <p className="pb-8">{t("earnWaterfall")}</p>
              {section !== "PMWaterfall" && (
                <a
                  className="text-blue-400 cursor-pointer"
                  onClick={(e) =>
                    switchSection(e, "PMWaterfall", t("tryWaterfall"))
                  }
                >
                  {t("tryWaterfall")}
                </a>
              )}

              <div className="flex flex-col mt-6">
                <div className="w-full xl:w-1/3">
                  {waterfallProgress === 100 ? (
                    <BadgeActiveButtons
                      showShare={() => trackShare(waterfallBadge)}
                      path={waterfallBadge}
                      trackDownload={() =>
                        trackDownload(
                          `kickoff-badge-wf${language}.png`,
                          waterfallBadge
                        )
                      }
                    />
                  ) : (
                    <BadgeInactiveButtons />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="flex mt-10">
            <div className="w-1/3">
              <img
                style={{ opacity: agileProgress === 100 ? 1 : 0.4 }}
                src={agileBadge}
                alt=""
              />
            </div>
            <div className="ml-8 w-2/3">
              <p className="pb-8">{t("earnAgile")}</p>
              {section !== "PMAgile" && (
                <a
                  className="text-blue-400 cursor-pointer"
                  onClick={(e) => switchSection(e, "PMAgile", t("tryAgile"))}
                >
                  {t("tryAgile")}
                </a>
              )}

              <div className="flex flex-col mt-6">
                <div className="w-full xl:w-1/3">
                  {agileProgress === 100 ? (
                    <BadgeActiveButtons
                      showShare={() => trackShare(agileBadge)}
                      path={agileBadge}
                      trackDownload={() =>
                        trackDownload(
                          `kickoff-badge-ag${language}.png`,
                          agileBadge
                        )
                      }
                    />
                  ) : (
                    <BadgeInactiveButtons />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BadgesPage;
